// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Receipt24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Receipt24Filled: FC<Receipt24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M3 21V4.929c0-.53.189-.985.567-1.362A1.857 1.857 0 0 1 4.929 3H19.07c.53 0 .985.189 1.362.567.378.377.567.831.567 1.362V21H3Zm6.429-3.857h7.714v-1.929H9.429v1.929Zm-2.572-4.179h10.286v-1.928H6.857v1.928Zm0-4.178h10.286V6.857H6.857v1.929Z" />
        </svg>
    );
};

export default Receipt24Filled;
